import type { ModalComponentProps } from "../../../types/modal.types";
import ConfirmModal from "../confirm.modal";

interface ConfirmProps extends ModalComponentProps {
  leftButton: {
    onClick?: () => void;
  },
  rightButton: {
    onClick?: () => void;
  }
}


export default function NavigationConfirmModal({ id, onClose, rightButton, leftButton }: ConfirmProps) {
  return (
    <ConfirmModal
      title=""
      enableOutsideClick={false}
      leftButton={{
        title: "취소",
        onClick: () => {
          leftButton.onClick?.();
          onClose?.();
        }
      }}
      rightButton={{
        title: "화면 이동",
        onClick: () => {
          rightButton.onClick?.();
          onClose?.();
        },
        variant: "danger"
      }}
      onClose={onClose}
      id={id}
    >
      <p className="text-[20px]">화면 이동 경고</p>
      <p className="text-[16px] text-black/60 py-[12px]">수정한 시세표 내용을 제출하지 않았다면 지금까지 입력한 시세표가 사라집니다. 화<br />면을 이동하시겠습니까?</p>
    </ConfirmModal>
  );
}